<template>
  <div class="ls-prefix-group">
    <span class="ls-label-text-prefix">R$</span>
    <money v-model="price" v-bind="money"></money>
  </div>
</template>

<script>
  import { Money } from 'v-money'

  export default {
    components: { Money },
    props: ['value'],
    data () {
      return {
        price: parseFloat(this.value).toFixed(2),
        money: {
          decimal: ',',
          thousands: '.',
          precision: 2,
          masked: false
        }
      }
    },
    watch: {
      price: function () {
        this.$emit('updateValue', (this.price))
      },
      value: function () {
        this.price = parseFloat(this.value).toFixed(2)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// MoneyInput.vue?8ccbe2f8